import type { DiaryViewT, StatefulDiaryT, StatefulTrackerViewT } from "@patient-watch/types";
import { getFormsToDoCounts, type FormsAuthCtx } from "../features/new/hooks/useFormsToDo";

/** Diary rows from the patient list query or fully stateful detail; used by nav / badge counters. */
export type DiaryForTodoCounters = DiaryViewT | StatefulDiaryT;

export function trackersViewForTodo(d: DiaryForTodoCounters): StatefulTrackerViewT[] {
    if ("trackers_view" in d && Array.isArray(d.trackers_view)) {
        return d.trackers_view as StatefulTrackerViewT[];
    }
    return [];
}

/** Total due entries across diaries (same rules as FormsToDo / the Diaries nav badge). */
export function countFormEntriesDueAcrossDiaries(diaries: DiaryForTodoCounters[], auth: FormsAuthCtx): number {
    return diaries.reduce((sum, diary) => {
        if (diary.end_date !== null) {
            return sum;
        }
        return sum + getFormsToDoCounts(trackersViewForTodo(diary), auth).taskCount;
    }, 0);
}

/** Whether this diary has patient-actionable due entries (same rules as the to-do page). */
export function trackerDueForTodo(d: DiaryForTodoCounters, auth?: FormsAuthCtx): boolean {
    if (d.end_date !== null) {
        return false;
    }

    const trackers = trackersViewForTodo(d);
    if (auth && trackers.length > 0) {
        return getFormsToDoCounts(trackers, auth).taskCount > 0;
    }

    return "tracker_due" in d && Boolean(d.tracker_due);
}
